import Direccion from "./Direccion";
var SInputPages = {
    "sc_direccion": Direccion
};
export default SInputPages;
